export default "/_next/static/chunks/fonts/Courgette-Regular-latin-3c4c8cf537207dccd972a0731e52f780.woff2";